module.exports = __webpack_public_path__ + "static/media/Group 120.51a7f1bc.png";